import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c3428c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section--column--center" }
const _hoisted_2 = { class: "TwoFactorWizardstep-size-security data--center" }
const _hoisted_3 = { class: "data--aligncenter aligndata--separate5" }
const _hoisted_4 = { class: "flex__separate05" }
const _hoisted_5 = { class: "code--field" }
const _hoisted_6 = { class: "flex__separate05" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QRCodeVue3 = _resolveComponent("QRCodeVue3")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('TwoFactorAuth.SetupScan')), 1),
      (_openBlock(), _createBlock(_component_QRCodeVue3, {
        value: _ctx.qrdata,
        key: _ctx.qrdata,
        height: _ctx.qrsize,
        width: _ctx.qrsize
      }, null, 8, ["value", "height", "width"])),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('TwoFactorAuth.SetupManual')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('TwoFactorAuth.SetupManualQuestion')), 1)
        ]),
        _createElementVNode("button", {
          class: "pi pi-question-circle",
          style: {"color":"var(--ingeteam-color)"},
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openHelp && _ctx.openHelp(...args)))
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.secretKey), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toBack && _ctx.toBack(...args))),
        class: "btn btn-primary p-x-2 border__rounded btn-2fa"
      }, _toDisplayString(_ctx.$t('wizard.previous')), 1),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toContinue && _ctx.toContinue(...args))),
        class: "btn btn-primary p-x-2 border__rounded btn-2fa"
      }, _toDisplayString(_ctx.$t('wizard.next')), 1)
    ])
  ]))
}